import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PHOTO_CAPTURE } from './photo-capture/photo-capture.port';
import { NETWORK_STATUS } from './network-status/network-status.port';
import { CAPTCHA_PORT } from './captcha/captcha.port';
import { XSRF_TOKEN_SOURCE } from './xsrf/xsrf-token-source.port';
import { DOCUMENT_OPENER } from './document-opener/document-opener.port';
import { WebDocumentOpenerService } from './document-opener/web-document-opener.service';
import { WebPhotoCaptureService } from './photo-capture/web-photo-capture.service';
import { WebNetworkStatusService } from './network-status/web-network-status.service';
import { WebCaptchaService } from './captcha/web-captcha.service';
import { WebXsrfTokenSource } from './xsrf/web-xsrf-token-source.service';

/**
 * Registers the web providers for the platform seam (design D1). Import into
 * every web app's app.config.ts — never into a shared lib, which must depend
 * only on the PHOTO_CAPTURE / NETWORK_STATUS tokens.
 */
export function provideWebPlatform(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: PHOTO_CAPTURE, useClass: WebPhotoCaptureService },
    { provide: NETWORK_STATUS, useClass: WebNetworkStatusService },
    { provide: CAPTCHA_PORT, useClass: WebCaptchaService },
    { provide: XSRF_TOKEN_SOURCE, useClass: WebXsrfTokenSource },
    { provide: DOCUMENT_OPENER, useClass: WebDocumentOpenerService },
  ]);
}
